import { useSyncExternalStore } from 'react'
import CompactSuccessModal from './CompactSuccessModal'
import { dismissConfirmation, getConfirmation, subscribeConfirmation } from '../lib/confirmation'

export default function ConfirmationHost() {
    const message = useSyncExternalStore(subscribeConfirmation, getConfirmation)
    return <CompactSuccessModal success={message} setSuccess={dismissConfirmation} overlayZIndex={13000} />
}
